// src/store/services/coach.js
import feathersClient, {
  makeServicePlugin,
  BaseModel
} from "../../feathers-client";

class Endorsement_Invite extends BaseModel {
  constructor (data, options) {
    super(data, options);
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = "Endorsement_Invite";
  // Define default properties here
  static instanceDefaults () {
    return {
      id: null,
      traineeCompetenciesId: null,
      userId:null,
      createdAt: null,
      updatedAt: null,
      inviteeEmail: null,
      inviteUserName:null,
      status:null
    };
  }
}
const servicePath = "endorsement-invite";
const servicePlugin = makeServicePlugin({
  Model: Endorsement_Invite,
  service: feathersClient.service(servicePath),
  servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
});

export default servicePlugin;
